import http from 'hub-http/clients/apiClient';
import { registerQuery, useLazyQuery } from 'data-fetching-client';
import { reportError } from 'automation-ui-core/errors/utils/reportError';
export const RESOLVE_DATA_TOKENS_FIELDNAME = 'resolveDataTokens';
export const RESOLVE_DATA_TOKENS = registerQuery({
  fieldName: RESOLVE_DATA_TOKENS_FIELDNAME,
  args: ['flowId', 'objectTypeId', 'objectId', 'action'],
  fetcher({
    flowId,
    objectTypeId,
    objectId,
    action
  }) {
    return http.post('flow-doctor/v3/execution/resolve-data-tokens', {
      data: {
        flowId,
        objectTypeId,
        objectId,
        action
      }
    }).catch(error => {
      const errorWithInfo = error;
      reportError({
        error: errorWithInfo,
        tags: {}
      });
      return null;
    });
  }
});
export const useLazyResolveDataTokens = ({
  flowId,
  objectTypeId,
  objectId,
  action
}) => {
  const query = useLazyQuery(RESOLVE_DATA_TOKENS, {
    variables: {
      flowId,
      objectTypeId,
      objectId: objectId,
      action: action
    }
  });
  return query;
};